export default customElements.define('w-multiple-transfer-builder', class MultipleTransferBuilder extends wealthify.CustomElementBaseClass {

    // TODO: this component is too specific, in any redesign of the pension consolidation pages
    // we should look to either refactor this component, or remove it in favour
    // of a set of more generic components
    constructor () {
        const styleSelector = 'c-multiple-transfer-builder';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `
            <div class="${styleSelector}__container" data-root>
                <h3 data-transfer-form-heading></h3>
                <p data-transfer-form-description></p>
                <p class="${styleSelector}__transfer-form-sub-message" data-transfer-form-sub-message></p>

                <!--Transfer Cards-->
                <div data-transfer-cards-section></div>

                <!--Transfer Form-->
                <w-section data-transfer-form>
                    <w-grid collapsed="true">
                        <w-grid-item spantablet="100" spandesktop="50">
                            <w-formgroup-v2 class="${styleSelector}__total-transfer-formgroup" erroronblur="true" data-total-transfer-formgroup>
                                <w-textbox-v2 key="transfer-value-input" prefix="£" type="integer" data-slot="input" data-total-transfer-input></w-textbox-v2>
                            </w-formgroup-v2>
                        </w-grid-item>
                        <w-grid-item spantablet="100" spandesktop="50">
                            <w-formgroup-v2 class="${styleSelector}__provider-search-formgroup" label="Provider (Optional)" data-transfer-provider name="ProviderName" data-filter="escapespecialcharacters" data-js="providername">
                                <w-search-select filteroptions="false" key="transfer-provider-search" data-slot="input" data-provider-search>
                                    <w-textbox-v2 autocomplete="false" key="transfer-provider-input"></w-textbox-v2>
                                </w-search-select>
                            </w-formgroup-v2>
                        </w-grid-item>
                        <w-grid-item spantablet="100" data-transfer-slider-section>
                            <w-formgroup-v2 erroronblur="false" data-transfer-slider-formgroup>
                                <w-slider label="Label" fillbar="true" data-slot="input" data-transfer-slider>
                                    <w-textbox class="u-text__colour--black" data-slider-textbox key="slider-input" prefix="£" type="integer" data-slot="input"></w-textbox>
                                </w-slider>
                            </w-formgroup-v2>
                        </w-grid-item>
                        <w-grid-item spantablet="100">
                            <w-button fullwidth="true" iconright="caret-forward" data-add-transfer-button></w-button>
                        </w-grid-item>
                        <w-grid-item spantablet="100">
                            <w-button fullwidth="true" iconright="caret-forward" data-update-transfer-button></w-button>
                        </w-grid-item>
                    </w-grid>
                </w-section>
                <w-button fullwidth="true" iconright="caret-forward" data-another-transfer-button></w-button>

                <!--Transfer Card Template-->
                <template data-transfer-card-template>
                    <w-section class="${styleSelector}__transfer-card" variant="light">
                        <w-grid class="${styleSelector}__transfer-card-grid collapsed="true">
                            <w-grid-item spantablet="100" spandesktop="50">
                                <p id="provider"></p>
                                <p id="totalValue"></p>
                                <p id="transferAmount"></p>
                            </w-grid-item>
                            <w-grid-item hidemobile="true" hidetablet="true" justifycontent="end" alignitems="end">
                                <w-chip class="${styleSelector}__transfer-card-delete-button" id="delete-chip" iconleft="bin" label="Remove" type="primary-warning" context="button"></w-chip>
                                <w-chip id="edit-chip" iconleft="pencil" label="Edit" context="button"></w-chip>
                            </w-grid-item>
                            <w-grid-item hidedesktop="true">
                                <w-chip class="${styleSelector}__transfer-card-delete-button" id="mobile-delete-chip" iconleft="bin" label="Remove" type="primary-warning" context="button"></w-chip>
                                <w-chip id="mobile-edit-chip" iconleft="pencil" label="Edit" context="button"></w-chip>
                            </w-grid-item>
                        </w-grid>
                    </w-section>
                </template>
            </div>`,
            cacheDom: [
                'data-another-transfer-button',
                'data-add-transfer-button',
                'data-total-transfer-formgroup',
                'data-transfer-card-template',
                'data-transfer-cards-section',
                'data-transfer-form',
                'data-transfer-form-description',
                'data-transfer-form-heading',
                'data-transfer-form-sub-message',
                'data-transfer-provider',
                'data-provider-search',
                'data-transfer-slider-formgroup',
                'data-transfer-slider-section',
                'data-update-transfer-button',
                'data-transfer-slider',
                'data-total-transfer-input'
            ]
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);

            this.unknownProviderNumber = 1;
            this.storedProviderInput = '';

            if (this.providerlisturl && this.providerlisturl !== '') {
                this.dom.providerSearch.addEventListener('valuechange', this._updateProviderList.bind(this));
            }

            this.dom.transferSlider.addEventListener('valuechange', this._checkSliderValidation.bind(this));

            this.dom.totalTransferInput.addEventListener('valuechange', () => {
                this._updateSliderLimits();
                this._showOrHideSections();
            });

            this.dom.addTransferButton.onclickprop = this._addTransfer.bind(this);

            this.dom.updateTransferButton.onclickprop = this._updateTransfer.bind(this);

            this.dom.anotherTransferButton.onclickprop = function() {
                this.dom.transferForm.classList.remove('u-display__none');
                this.dom.anotherTransferButton.classList.add('u-display__none');
                this._showOrHideSections();
            }.bind(this);

            // Hide transfer form if any transfers have been pre-populated
            if (this.totalamounttransferred > 0 && this.totalamounttransferred > this.minimumtransferamount){
                this.dom.transferForm.classList.add('u-display__none');
            }

            this._setInputMinimum();
            this._updateUI();
            this._updateSliderLimits();

        };

    }

    static get validAccountTypes () {
        return [
            'sipp'
        ];
    }

    static get validBackgroundColours () {
        return [
            'light',
            'slate-grey-dark'
        ];
    }

    static defaultDescription = 'We\'ll need some information so that we can complete your transfer - you can usually find this on your pension statement.';

    static get observedProps() {
        return [
            new wealthify.Prop('accounttype', {
                required: true,
                type: wealthify.propTypes.ArrayItem(this.validAccountTypes)
            }),

            new wealthify.Prop('allowzerotransferamount', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),

            new wealthify.Prop('minimumtransferamount', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),

            new wealthify.Prop('providerlisturl'),

            new wealthify.Prop('transferformbackground', {type: wealthify.propTypes.ArrayItem(this.validBackgroundColours)}),

            new wealthify.Prop('transfers', {
                default: [],
                type: wealthify.propTypes.Array()
            }),

            new wealthify.Prop('description', {default: this.defaultDescription}),

            wealthify.props.DarkMode()
        ];
    }

    get propCallbacks() {
        return {
            accounttype: () => {
                this._updateCopy();
            },

            allowzerotransferamount: () => {},

            description: (value) => {
                this.dom.transferFormDescription.innerHTML = value;
            },

            minimumtransferamount: () => {
                this._setInputMinimum();
            },

            providerlisturl: () => {},

            transferformbackground: () => {
                this.dom.transferForm.variant = this.transferformbackground;

                if (this.transferformbackground === 'slate-grey-dark'){
                    this.darkmode = true;
                }
            },

            transfers: () => {
                this._updateUI();
            }
        };
    }

    _buildTransferCards() {
        this.dom.transferCardsSection.innerHTML = '';

        if (this.transfers.length > 0) {
            this.dom.transferCardsSection.innerHTML = '<h4 class="u-margin__bottom-mobile--spacing-xl">Existing pension(s)</h4>';

            Array.prototype.forEach.call(this.transfers, (transfer, index) => {
                let card = this.dom.transferCardTemplate.content.cloneNode(true);

                const totalValuePrefix = this.accounttype == 'sipp' ? 'Pension' : 'Transfer';

                card.querySelector('#provider').innerHTML = `Provider: <b>${transfer[Object.keys(transfer).find(key => key.toLowerCase() === 'provider')]}</b>`;
                card.querySelector('#totalValue').innerHTML = `${totalValuePrefix} Value: <b>${wealthify.type.number.toCurrency(transfer[Object.keys(transfer).find(key => key.toLowerCase() === 'totalvalue')])}</b>`;
                card.querySelector('#transferAmount').innerHTML = `Transferring: <b>${wealthify.type.number.toCurrency(transfer[Object.keys(transfer).find(key => key.toLowerCase() === 'transferamount')])}</b>`;

                let deleteFunction = function() {
                    this._deleteTransfer(index);
                }.bind(this);

                let editFunction = function() {
                    this._editTransfer(index);
                }.bind(this);

                card.querySelector('#delete-chip').onclickprop = deleteFunction;
                card.querySelector('#mobile-delete-chip').onclickprop = deleteFunction;
                card.querySelector('#edit-chip').onclickprop = editFunction;
                card.querySelector('#mobile-edit-chip').onclickprop = editFunction;

                this.dom.transferCardsSection.appendChild(card);
            });
        }
    }

    _deleteTransfer(index) {
        if (index > -1) {
            let result = confirm('Are you sure you want to delete this transfer?');

            if (result) {
                this.transfers.splice(index, 1);
                this.dom.addTransferButton.classList.remove('u-display__none');
                this._updateUI();

                this.dispatchEvent(new Event('transfersupdated'));
            }
        }
    }

    _editTransfer(index) {
        this.selectedTransferIndex = index;
        let selectedTransfer = this.transfers[index];

        // Show the transfer form
        this.dom.transferForm.classList.remove('u-display__none');
        this.dom.updateTransferButton.classList.remove('u-display__none');
        this.dom.addTransferButton.classList.add('u-display__none');
        this.dom.anotherTransferButton.classList.add('u-display__none');

        this.dom.totalTransferInput.value = selectedTransfer['totalValue'];
        this._updateSliderLimits();
        this.dom.providerSearch.value = selectedTransfer['provider'];
        this.dom.transferSlider.value = selectedTransfer['transferAmount'];

        this._showOrHideSections();
        this.dom.transferForm.scrollIntoView();
    }

    _updateSliderLimits() {
        if (this.dom.totalTransferInput == null || this.dom.totalTransferInput.value == null || this.dom.totalTransferInput.value < this.minimumtransferamount) {
            if (this.dom.transferSlider){
                this.dom.transferSlider.disabledprop = true;
            }

            return;
        }

        this.dom.transferSlider.disabledprop = false;

        const stepValue = this.dom.totalTransferInput.value * 0.01;

        this.dom.transferSlider.ranges = {
            '0': [0, stepValue],
            '100': [this.dom.totalTransferInput.value]
        };

        this.dom.transferSlider.max = this.dom.totalTransferInput.value;
        this.dom.transferSlider.value = this.dom.totalTransferInput.value;
    }

    _enableOrDisableTransferButtons() {
        this.dom.addTransferButton.disabledprop = !this.dom.totalTransferInput.valid || !this.dom.transferSlider.valid;
        this.dom.updateTransferButton.disabledprop = !this.dom.totalTransferInput.valid || !this.dom.transferSlider.valid;
    }

    _showOrHideSections() {
        if (this.dom.totalTransferInput == null){
            return;
        }

        if (this.transfers.length == 0) {
            this.dom.transferForm.classList.remove('u-display__none');
        }

        const sliderSectionClassAction = this.dom.totalTransferInput.valid && this.dom.totalTransferInput.value != null && this.dom.totalTransferInput.value !== '' ? 'remove' : 'add';
        const anotherTransferClassAction = this.dom.transferForm.classList.contains('u-display__none') ? 'remove' : 'add';
        const updateTransferClassAction = this.dom.addTransferButton.classList.contains('u-display__none') ? 'remove' : 'add';

        this.dom.transferSliderSection.classList[sliderSectionClassAction]('u-display__none');
        this.dom.anotherTransferButton.classList[anotherTransferClassAction]('u-display__none');
        this.dom.updateTransferButton.classList[updateTransferClassAction]('u-display__none');

        this._enableOrDisableTransferButtons();
    }

    _checkSliderValidation() {
        const invalid = this.allowzerotransferamount ? this.dom.transferSlider.value > 0 && this.dom.transferSlider.value < this.minimumtransferamount : this.dom.transferSlider.value < this.minimumtransferamount;

        this.dom.transferSlider.validoverride = invalid ? 'false' : 'true';

        this._enableOrDisableTransferButtons();
    }

    _addTransfer() {
        this.transfers.push(this._buildTransferObject());

        this.dom.transferForm.classList.add('u-display__none');

        this._updateUI();
        this._resetTransferFormFields();

        this.dispatchEvent(new Event('transfersupdated'));
    }

    _updateTransfer() {
        this.transfers[this.selectedTransferIndex] = this._buildTransferObject();

        this.dom.transferForm.classList.add('u-display__none');
        this.dom.addTransferButton.classList.remove('u-display__none');

        this._updateUI();
        this._resetTransferFormFields();

        this.dispatchEvent(new Event('transfersupdated'));
    }

    _buildTransferObject() {
        return {
            totalValue: wealthify.type.number.toNumber(this.dom.totalTransferInput.value),
            provider: this._getProviderFromInput(),
            transferAmount: this.dom.transferSlider.value,
        };
    }

    _getProviderFromInput() {
        const noUserInput = (this.dom.providerSearch.value === undefined || this.dom.providerSearch.value === '');
        const unknownProviderName = this.accounttype == 'sipp' ? 'Unknown Pension' : 'Unknown Transfer';

        let providerName;

        if (noUserInput){
            providerName = `${unknownProviderName} ${this.unknownProviderNumber}`;
            this.unknownProviderNumber++;
        } else {
            providerName = this.dom.providerSearch.value;
        }

        return providerName;
    }

    _resetTransferFormFields() {
        this.dom.totalTransferInput.value = '';

        if (this.accounttype === 'sipp') {
            this.dom.providerSearch.value = '';
            this.dom.providerSearch.datalistoptions = [];
            this.dom.providerSearch.dom.datalist.classList.add('u-display__none');
        }
    }

    async _updateProviderList() {
        if (this.accounttype === 'sipp' && this.storedProviderInput !== this.dom.providerSearch.value && this.dom.providerSearch.value.length) {
            const providers = this._getProviders().then((response) => {
                if (response !== undefined && response.length > 0) {
                    const providers = response.map(a => a.Data.Name);

                    this.dom.providerSearch.datalistoptions = providers;
                }
            });

            await Promise.all([providers]);

            this.storedProviderInput = this.dom.providerSearch.value;
        }
    }

    _getProviders() {
        const config = {
            data: {phrase: this.dom.providerSearch.value},
            contentType: 'application/json',
            url: this.providerlisturl
        };

        return wealthify.request.send(config);
    }

    _setInputMinimum() {
        if (this.dom.totalTransferInput) {
            this.dom.totalTransferInput.min = this.minimumtransferamount;
        }
    }

    _updateUI () {
        this._updateSliderLimits();
        this._buildTransferCards();
        this._showOrHideSections();
        this._updateCopy();

        this.totalamounttransferred = 0;
        this.totalvalue = 0;

        if (this.transfers && this.transfers.length > 0) {
            Array.prototype.forEach.call(this.transfers, (transfer) => {
                this.totalvalue += transfer[Object.keys(transfer).find(key => key.toLowerCase() === 'totalvalue')];
                this.totalamounttransferred += transfer[Object.keys(transfer).find(key => key.toLowerCase() === 'transferamount')];
            });
        }
    }

    _updateCopy() {
        switch (this.accounttype) {
        case 'sipp':
            this._sippSetup();
            break;

        default:
            break;
        }
    }

    _sippSetup() {
        const minimumTransferErrorMessage = `£${this.minimumtransferamount} is the minimum transfer amount allowed for a Wealthify pension`;

        this.dom.totalTransferFormgroup.error = this.dom.transferSliderFormgroup.error = minimumTransferErrorMessage;
        this.dom.totalTransferFormgroup.label = 'Value of pension';
        this.dom.transferSliderFormgroup.label = 'How much would you like to transfer from this pension?';
        this.dom.addTransferButton.label = 'Add this pension';
        this.dom.updateTransferButton.label = 'Update this pension';
        this.dom.anotherTransferButton.label = 'Add another pension';

        const transfersAdded = this.transfers && this.transfers.length > 0;

        this.dom.transferFormHeading.innerHTML =  transfersAdded ? 'Add another pension' : 'Add existing pension(s)';
        this.dom.transferFormSubMessage.innerHTML = '<b>We\'re unable to accept any pensions that you\'re already taking an income from, or that have defined benefits or guarantees.</b>';
    }

});